import { useContext } from 'react';

import { ExportContext } from './ExportContextDefinition';

export const useExport = () => {
  const context = useContext(ExportContext);
  if (context === undefined) {
    throw new Error('useExport must be used within an ExportProvider');
  }
  return context;
};
